import React from 'react'
import InputLabel from '@material-ui/core/InputLabel'
import { theme } from '../../../../src/Root.mui-theme'

const component = (props) => {
    if (!(props?.labelInside)) {
        return (
            <InputLabel
                shrink
                htmlFor={`TextField-custom-${props?.key || Math.random() * 2.5}`} // previene que se repitan los ids si no se pasa key
                style={{
                    top: '-22px',
                    fontWeight: 'bold',
                    fontSize: props?.size === 'small' ? '12px' : '14px',
                    lineHeight: props?.size === 'small' ? '16px' : '19px',
                    width: 'fit-content',
                    color: theme.palette.grey[600],
                    marginBottom: '4px',
                    transform:'none'
                }}
            >
                {props?.label}{' '}
                {props?.showLabelOptional && (
                    <span
                        style={{
                            color:theme.palette.grey[500],
                            fontWeight: 'normal',
                            fontSize:'11px',
                            lineHeight:'15px'
                        }}
                    >
                        (opcional)
                    </span>
                )}
            </InputLabel>
        )
    }
    return null
}

export const LabelOutside = React.memo(component)